// === Config ===
const EFX_MIN_LEN    = 2;
const EFX_TYPES      = "product";
const EFX_LIMIT      = 20;   // slider için üst limit
const EFX_LIMIT_SEARCH = 12; // yazarken getirilecek item sayısı
const EFX_SLIDE_SIZE = 4;    // her sayfada 4 kart
const RECENT_KEY = "efx_recent_searches";
const RECENT_MAX = 10;

// --- EFX Spinner CSS (auto inject) ---
(function ensureSpinnerCSS(){
  if (document.getElementById('efx-spinner-styles')) return;
  const css = `
  .efx-loading{display:flex;align-items:center;justify-content:center;min-height:240px}
  .efx-spinner{width:42px;height:42px;border:3px solid rgba(0,0,0,.15);border-top-color:currentColor;border-radius:50%;animation:efx-spin .8s linear infinite}
  @keyframes efx-spin{to{transform:rotate(360deg)}}
  `;
  const style = document.createElement('style');
  style.id = 'efx-spinner-styles';
  style.textContent = css;
  document.head.appendChild(style);
})();

// --- Search state ---
let inSearchMode = false;
let lastSearchResults = null; // son arama (predictive+search) ürün listesi
let efxSearchReqId = 0;

let dbVendors = [];

//=== Proxy ===
async function sendDataToProxy(payload) {
  try {
    const response = await fetch('/apps/efx-mila', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const ct = response.headers.get('content-type') || '';
    const raw = await response.text(); // önce ham metni al

    if (!response.ok) {
      throw new Error(`HTTP ${response.status} ${response.statusText}`);
    }

    // JSON ise parse et; değilse metni geri dön
    const result = ct.includes('application/json')
      ? JSON.parse(raw)
      : raw;

    return result;
  } catch (err) {
    console.error('[proxy] parse/req error:', err);
    return undefined;
  }
}

const payload = { action: 'getVendors' };

sendDataToProxy(payload).then((res) => {
  if (res?.ok) {
    dbVendors = res.vendors;
  } else {
    console.error("Backend error:", res?.error || res);
  }
});



// === Abort / Timeout / Cache ===
let efxCtrl = { pred: null, search: null };
function efxCancelInFlight() {
  try { efxCtrl.pred?.abort(); } catch {}
  try { efxCtrl.search?.abort(); } catch {}
  efxCtrl.pred = null;
  efxCtrl.search = null;
}

// timeout + harici signal birleşik (AbortSignal.any yoksa fallback)
async function efxFetchWithTimeout(input, init = {}, ms = 8000) {
  const timeoutCtrl = new AbortController();
  const baseInit = { ...init };
  const signals = [timeoutCtrl.signal];
  if (init.signal) signals.push(init.signal);

  let signalToUse;
  if (typeof AbortSignal !== "undefined" && AbortSignal.any) {
    signalToUse = AbortSignal.any(signals);
  } else if (signals.length > 1) {
    const combo = new AbortController();
    const abortOnce = (reason) => { try { combo.abort(reason || "aborted"); } catch {} };
    signals.forEach(s => s.addEventListener("abort", () => abortOnce(s.reason), { once: true }));
    signalToUse = combo.signal;
  } else {
    signalToUse = signals[0];
  }

  const id = setTimeout(() => { try { timeoutCtrl.abort("timeout"); } catch {} }, ms);
  try {
    delete baseInit.signal; // birleşik signal kullanılacak
    return await fetch(input, { ...baseInit, signal: signalToUse });
  } finally {
    clearTimeout(id);
  }
}

const efxCache = new Map(); // key -> {ts, data}
function efxGetCache(key, maxAgeMs = 45000) {
  const hit = efxCache.get(key);
  if (!hit) return null;
  if (Date.now() - hit.ts > maxAgeMs) { efxCache.delete(key); return null; }
  return hit.data;
}
function efxSetCache(key, data) { efxCache.set(key, { ts: Date.now(), data }); }

// === Helpers ===
const efxIsCoarse = () =>
  (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ||
  ('ontouchstart' in window);

function efxFindDbVendor(name) {
  if (!name || !Array.isArray(dbVendors) || dbVendors.length === 0) return null;
  const key = String(name).trim().toLowerCase();
  return dbVendors.find(v =>
    String(v.name || v.vendor || "").trim().toLowerCase() === key
  ) || null;
}
function efxIsVendorActive(vendorRow) {
  const st = vendorRow?.status;
  if (st === undefined || st === null || st === "") return true;
  const n = Number(st);
  return Number.isNaN(n) ? Boolean(st) : n !== 0;
}
function efxIsRootCollections(u) {
  if (!u) return true;
  try {
    const url = new URL(u, location.origin);
    const p = url.pathname.replace(/\/+/g, '/');
    return /^\/collections\/?$/.test(p);
  } catch {
    const s = String(u).trim().replace(/\/+/g, '/');
    return s === 'collections' || s === '/collections' || s === '/collections/';
  }
}
function efxIsMalformedCollectionUrl(u) {
  if (!u) return true;
  const s = String(u).trim();
  const httpCount = (s.match(/https?:\/\//gi) || []).length;
  if (httpCount > 1) return true;
  if (/\/collections\/https?:\/\//i.test(s)) return true;
  if (efxIsRootCollections(s)) return true;
  try {
    const url = new URL(s, location.origin);
    const p = url.pathname.replace(/\/+/g, '/');
    if (!/^\/collections\/[^\/?#]+\/?$/.test(p)) return true;
    const slug = p.split('/').filter(Boolean)[1] || '';
    if (/^https?:/i.test(slug)) return true;
  } catch {
    const norm = s.replace(/\/+/g, '/');
    if (norm.startsWith('/collections/')) {
      const tail = norm.replace(/^\/collections\//, '');
      if (!tail || /https?:\/\//i.test(tail)) return true;
    }
  }
  return false;
}
function efxNormalizeCollectionUrl(urlOrHandle) {
  if (!urlOrHandle) return null;
  const u = String(urlOrHandle).trim();
  let candidate = (/^https?:\/\//i.test(u) || u.startsWith('/collections/'))
    ? u
    : `/collections/${u}`;
  if (efxIsMalformedCollectionUrl(candidate)) return null;
  return candidate;
}
function efxGetVendorCollectionUrl(vendorName) {
  const row = efxFindDbVendor(vendorName);
  if (!row) return null;
  if (!efxIsVendorActive(row)) return null;
  const normalized = efxNormalizeCollectionUrl(row.url);
  return normalized || null;
}
function efxVendorSearchHref(query, vendorName) {
  let href = `/search?q=${encodeURIComponent(query)}&filter.v.availability=1&sort_by=relevance`;
  if (vendorName) href += `&filter.p.vendor=${encodeURIComponent(vendorName)}`;
  return href;
}
const efxBounce = (fn, wait = 220) => {
  let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), wait); };
};
function efxChunk(arr, size) {
  const out = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
}
function efxHoverIntent(el, onIntent, onLeave, delay = 120) {
  let t = null;
  el.addEventListener("mouseenter", () => {
    t = setTimeout(() => { onIntent && onIntent(); }, delay);
  });
  el.addEventListener("mouseleave", () => {
    if (t) { clearTimeout(t); t = null; }
    onLeave && onLeave();
  });
}
function efxUpdateSidebarVisibility() {
  const isNarrow = window.innerWidth < 1200;
  document.querySelectorAll(".efx-search-overlay .efx-sidebar").forEach((sb) => {
    const inResults = sb.closest(".efx-search-results") !== null && !$results.hidden;
    const shouldHide = isNarrow && inSearchMode && inResults;
    sb.style.display = shouldHide ? "none" : "";
  });
}
function efxShowSpinner(mount){
  if(!mount) return;
  mount.innerHTML = `<div class="efx-loading"><div class="efx-spinner" role="status" aria-label="Yükleniyor"></div></div>`;
}

// Boyamaya izin ver (2 rAF: bazı Chrome sürümlerinde daha garantili)
async function efxNextPaint() {
  await new Promise(r => requestAnimationFrame(r));
  await new Promise(r => requestAnimationFrame(r));
}

// Sonuç kabuğunu hazırlayıp grid'i döndür
function efxEnsureResultsShell() {
  $default.hidden = true;
  $results.hidden = false;
  if (!$results.__shell) {
    $results.innerHTML = `
      <div class="efx-upper-bar">
        <div class="efx-vendors-bar">
          <h4 style="margin-bottom:0;">Popüler Markalar</h4>
          <ul class="efx-pop-vendors"></ul>
        </div>
        <div style="display:flex;">
          <div class="efx-popUp-close" onclick="efxClose()">✖</div>
        </div>
      </div>
      <div class="efx-cols">
        <aside class="efx-sidebar">
          <h4>Arama</h4>
          <div class="efx-query"></div>
        </aside>
        <section class="efx-main">
          <div class="efx-section-head">
            <div class="efx-section-title">Ürünler</div>
            <a class="efx-see-all-top" href="#" hidden>Tümünü Gör <span aria-hidden="true">→</span></a>
          </div>
          <div class="efx-product-grid"></div>
          <div class="efx-search-all-products"></div>
        </section>
      </div>`;
    $results.__shell = true;
  }
  return $results.querySelector('.efx-product-grid');
}

function efxCardHTML(p) {
  const title = p.title || "";
  const shortTitle = title.length > 50 ? title.substring(0, 50) + "…" : title;
  function formatShopifyPrice(val) {
    if (val == null) return "";
    const num = parseFloat(val);
    return num.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " TL";
  }
  const price = formatShopifyPrice(p.price);
  const compareAtValid = p.compareAtPrice && p.compareAtPrice > p.price;
  const compareAt = compareAtValid ? formatShopifyPrice(p.compareAtPrice) : null;
  let discountBadge = "";
  if (compareAtValid) {
    const discount = Math.round(((p.compareAtPrice - p.price) / p.compareAtPrice) * 100);
    discountBadge = `<div class="efx-discount-badge">-${discount}%</div>`;
  }
  // Growave wishlist (product-block ile aynı): farklı veri şekillerinden id/variant çöz
  const pid = p.id || null;
  const vid = p.variantId || p.variant_id ||
    (Array.isArray(p.variants) && p.variants[0] && p.variants[0].id) || "";
  const wishlistHTML = pid
    ? `<div class="wishlist-engine efx-wishlist"
           data-product_id="${pid}"
           data-variant_id="${vid}"
           data-full_button="false"
           data-css="true"></div>`
    : "";
  return `
    <a class="efx-card" href="${p.url}">
      <div class="efx-card-media">
        ${wishlistHTML}
        ${p.image ? `<img loading="lazy" src="${p.image}" alt="">` : ""}
        ${discountBadge}
      </div>
      <div class="efx-card-details">
        <div class="efx-card-vendor">${p.vendor || ""}</div>
        <div class="efx-card-title">${shortTitle}</div>
        ${price ? `<div class="efx-card-price">
            ${compareAt
              ? `<span class="efx-card-compare">${compareAt}</span> <span class="efx-card-final">${price}</span>`
              : `<span class="efx-card-final">${price}</span>`}
          </div>` : ""}
      </div>
    </a>
  `;
}

// Growave wishlist'i dinamik (JS ile basılan) kartlar için yeniden tarat.
// Growave app-embed olarak yüklenir; global'i kuruluma göre değişebildiği için
// yalnızca gerçekten fonksiyon olan bir API bulunursa çağrılır (yoksa no-op).
function efxInitWishlist(root) {
  if (!root || !root.querySelector(".wishlist-engine")) return;
  try {
    const candidates = [
      window.ssw && window.ssw.reInit,
      window.ssw && window.ssw.init,
      window.gw && window.gw.wishlist && window.gw.wishlist.init,
      window.Growave && window.Growave.wishlist && window.Growave.wishlist.init,
    ];
    for (const fn of candidates) {
      if (typeof fn === "function") { fn.call(window.ssw || window.gw || window.Growave || window, root); return; }
    }
    // Bilinen global yoksa: Growave gözlemcisi yakalasın diye olay yay.
    document.dispatchEvent(new CustomEvent("growave:wishlist:reinit", { detail: { root } }));
  } catch (e) {
    console.warn("Wishlist init atlandı:", e);
  }
}

// Kalbe tıklayınca kartın linkine gidilmesin (Growave'in toggle'ı çalışmaya devam eder)
document.addEventListener("click", (e) => {
  if (e.target.closest && e.target.closest(".efx-card .efx-wishlist")) e.preventDefault();
}, true);

// mountEl: içine slider yerleşecek container
function efxInitSlider(mountEl, items) {
  if (!mountEl) return;
  const data = (items || []).slice(0, EFX_LIMIT | 0);
  const pages = efxChunk(data, EFX_SLIDE_SIZE);

  mountEl.innerHTML = `
    <div class="efx-slider" data-page="0" aria-roledescription="carousel">
      <button class="efx-slide-btn efx-prev" aria-label="Önceki" ${pages.length <= 1 ? "disabled" : ""}><i class="fa fa-chevron-left"></i></button>
      <div class="efx-track-wrap">
        <div class="efx-track" style="transform:translateX(0%)">
          ${pages.map(pg => `
            <div class="efx-page">
              ${pg.map(efxCardHTML).join("")}
            </div>
          `).join("")}
        </div>
      </div>
      <button class="efx-slide-btn efx-next" aria-label="Sonraki" ${pages.length <= 1 ? "disabled" : ""}><i class="fa fa-chevron-right"></i></button>
    </div>
  `;

  // Yeni basılan kartlardaki Growave wishlist butonlarını başlat
  efxInitWishlist(mountEl);

  if (window.innerWidth < 1200) return;

  const $slider = mountEl.querySelector(".efx-slider");
  const $track  = mountEl.querySelector(".efx-track");
  const $prev   = mountEl.querySelector(".efx-prev");
  const $next   = mountEl.querySelector(".efx-next");
  const pageCount = pages.length;

  function update(dir) {
    if (pageCount <= 1) return;
    let page = +$slider.dataset.page;
    if (dir === "next") page = Math.min(page + 1, pageCount - 1);
    if (dir === "prev") page = Math.max(page - 1, 0);
    $slider.dataset.page = page;
    $track.style.transform = `translateX(-${page * 100}%)`;
    if ($prev) $prev.disabled = page === 0;
    if ($next) $next.disabled = page === pageCount - 1;
  }

  $prev?.addEventListener("click", () => update("prev"));
  $next?.addEventListener("click", () => update("next"));

  let sx = 0, dx = 0;
  $track.addEventListener("touchstart", (e) => { sx = e.touches[0].clientX; }, {passive:true});
  $track.addEventListener("touchmove", (e) => { dx = e.touches[0].clientX - sx; }, {passive:true});
  $track.addEventListener("touchend", () => {
    if (Math.abs(dx) > 50) update(dx < 0 ? "next" : "prev");
    dx = 0;
  });
}

// === Fetchers ===
async function efxFetchPredictive(q) {
  const ck = `pred:${q}`;
  const c = efxGetCache(ck);
  if (c) return c;

  efxCtrl.pred = new AbortController();
  const p = new URLSearchParams({
    q,
    "resources[type]": EFX_TYPES,
    "resources[limit]": EFX_LIMIT_SEARCH
  });
  const res = await efxFetchWithTimeout(`/search/suggest.json?${p}`, {
    headers: { Accept: "application/json" },
    signal: efxCtrl.pred.signal
  }, 2200);
  if (!res.ok) throw new Error("HTTP " + res.status);
  const json = await res.json();
  efxSetCache(ck, json);
  return json;
}

// /search?view=efx-json şablonundan ürünler
async function efxFetchSearch(q) {
  const ck = `search:${q}`;
  const c = efxGetCache(ck);
  if (c) return c;

  efxCtrl.search = new AbortController();
  const url = `/search?view=efx-json&q=${encodeURIComponent(q)}`;
  const res = await efxFetchWithTimeout(url, {
    headers: { 'Accept': 'application/json' },
    signal: efxCtrl.search.signal
  }, 3500);
  if (!res.ok) throw new Error("Search fetch HTTP " + res.status);
  const json = await res.json();
  efxSetCache(ck, json);
  return json;
}

async function efxFetchPopularProducts(handle, limit = 20) {
  const res = await efxFetchWithTimeout(`/collections/${handle}?view=efx-popular-json&limit=${limit}`, {}, 3500);
  if (!res.ok) throw new Error("Popular fetch HTTP " + res.status);
  return res.json();
}

async function efxFetchVendorPopularProducts(vendorTitle, limit = 20) {
  const url = `/collections/vendors?view=efx-popular-json&q=${encodeURIComponent(vendorTitle)}&limit=${limit}`;
  const res = await efxFetchWithTimeout(url, {}, 3500);
  if (!res.ok) throw new Error("Vendor fetch HTTP " + res.status);
  return res.json();
}

// === DOM ===
let $overlay = document.querySelector(".efx-search-overlay");
let $panel, $wrap, $results, $default;

if (!$overlay) {
  $overlay = document.createElement("div");
  $overlay.className = "efx-search-overlay";
  $panel = document.createElement("div");
  $panel.className = "custom-search-results";

  $wrap = document.createElement("div");
  $wrap.className = "custom-search-results__wrapper";

  $default = document.createElement("div");
  $default.className = "efx-search-default";
  $default.innerHTML = `
    <div class="efx-upper-bar">
      <div class="efx-vendors-bar">
        <h4 style="margin-bottom:0;">Popüler Markalar</h4>
        <ul class="efx-pop-vendors"></ul>
      </div>
      <div style="display:flex;">
        <div class="efx-popUp-close" onclick="efxClose()">✖</div>
      </div>
    </div>
    <div class="efx-cols">
      <aside class="efx-sidebar">
        <h4>Popüler Kategoriler</h4>
        <ul class="efx-pop-cats"></ul>
        <h4>Popüler Aramalar</h4>
        <ul class="efx-pop-queries"></ul>
      </aside>
      <section class="efx-main">
        <div class="efx-section-head">
          <div class="efx-section-title">Popüler Ürünler</div>
          <a class="efx-see-all-top" href="#" hidden>Tümünü Gör <span aria-hidden="true">→</span></a>
        </div>
        <div class="efx-product-grid"></div>
        <div class="efx-search-all-products"></div>
      </section>
    </div>
    <div class="efx-bottom">
      <h4 style="margin-bottom:0;">Geçmiş Aramalar</h4>
      <ul class="efx-pop-recent-search"></ul>
    </div>
  `;

  $results = document.createElement("div");
  $results.className = "efx-search-results";
  $results.hidden = true;

  // Mobil drawer header (CSS ile sadece <=767px gorunur)
  const drawerHdr = document.createElement("div");
  drawerHdr.className = "efx-drawer-header";
  drawerHdr.innerHTML = `
    <button type="button" class="efx-drawer-back" aria-label="Geri">
      <svg viewBox="0 0 10 16" width="11" height="18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8.2 1.2 1.6 8l6.6 6.8"/></svg>
    </button>
    <div class="efx-drawer-input-wrap">
      <svg class="efx-drawer-search-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
      <input type="search" class="efx-drawer-input" autocomplete="off" placeholder="Marka veya Ürün Arayın" enterkeyhint="search" />
      <button type="button" class="efx-drawer-clear" aria-label="Temizle" hidden>
        <svg viewBox="0 0 14 14" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12"/></svg>
      </button>
    </div>
  `;

  $wrap.appendChild(drawerHdr);
  $wrap.appendChild($default);
  $wrap.appendChild($results);
  $panel.appendChild($wrap);
  $overlay.appendChild($panel);
  document.body.appendChild($overlay);
}

// === Render ===
function efxRenderPopularCats(cats, activeHandle) {
  if (!cats || !cats.length) return;
  const defaultCat = cats[0];
  const visibleCats = cats.slice(1);
  if (!activeHandle) {
    activeCatHandle = defaultCat.handle;
    efxLoadPopular(defaultCat.handle);
  }
  const catsEl = $default.querySelector(".efx-pop-cats");
  catsEl.innerHTML = visibleCats.map(c => `
    <li data-handle="${c.handle}" class="${c.handle === activeHandle ? "is-active" : ""}">
      <a href="/collections/${c.handle}">
        <div class="cat-container">
          <span class="cat-title">${c.title}</span>
          <span class="cat-arrow">→</span>
        </div>
      </a>
    </li>
  `).join("");

  const hoverLoad = efxBounce((handle, li) => {
    if (handle && handle !== activeCatHandle) {
      activeCatHandle = handle;
      catsEl.querySelectorAll("li[data-handle]").forEach(el => {
        el.classList.toggle("is-active", el === li);
      });
      inSearchMode = false;
      lastSearchResults = null;
      efxLoadPopular(handle);
    }
  }, 120);

  if (!efxIsCoarse()) {
    catsEl.querySelectorAll("li[data-handle]").forEach(li => {
      efxHoverIntent(li, () => { hoverLoad(li.dataset.handle, li); });
    });
  }
}

function efxRenderPopularVendors(vendors) {
  const vendorsEl = $default.querySelector(".efx-pop-vendors");
  vendorsEl.innerHTML = (vendors || []).map(v => `
    <li data-vendor-handle="${v.handle}">
      <a href="/collections/${v.handle}">${v.title}</a>
    </li>
  `).join("");

  if (efxIsCoarse()) return;

  const hoverLoadVendor = efxBounce((vendorHandle, li) => {
    if (!vendorHandle) return;
    activeVendorName = vendorHandle;
    vendorsEl.querySelectorAll("li[data-vendor-handle]").forEach(el => {
      el.classList.toggle("is-active", el === li);
    });
    inSearchMode = false;
    lastSearchResults = null;
    efxLoadPopularVendor(vendorHandle);
  }, 120);

  vendorsEl.querySelectorAll("li[data-vendor-handle]").forEach(li => {
    efxHoverIntent(li, () => { hoverLoadVendor(li.dataset.vendorHandle, li); });
  });
}

async function efxPreviewQuery(query) {
  try {
    const data  = await efxFetchPredictive(query);
    const items = (data?.resources?.results?.products || []).slice(0, EFX_LIMIT);
    const normalized = items.map(it => ({
      id: it.id,
      variantId: it.variantId || (Array.isArray(it.variants) && it.variants[0] && it.variants[0].id) || "",
      url: it.url,
      image: it.image,
      title: it.title,
      price: it.price,
      compareAtPrice: it.compareAtPrice,
      handle: it.handle || efxExtractHandleFromUrl(it.url),
      vendor: it.vendor
    }));
    const grid = $default.querySelector(".efx-product-grid");
    efxInitSlider(grid, normalized);
  } catch (err) {
    console.error(`Query preview (${query}) yüklenemedi:`, err);
  }
}

function efxRenderQueries(queries) {
  const qEl = $default.querySelector(".efx-pop-queries");
  qEl.innerHTML = (queries || []).map(q => `
    <li data-query="${q}">
      <a href="/search?q=${encodeURIComponent(q)}" class="query-container">
        <span class="query-title">${q}</span>
        <span class="cat-arrow">→</span>
      </a>
    </li>
  `).join("");

  const hoverLoadQuery = efxBounce((query, li) => {
    if (!query) return;
    qEl.querySelectorAll("li[data-query]").forEach(el => {
      el.classList.toggle("is-active", el === li);
    });
    const catsEl = $default.querySelector(".efx-pop-cats");
    if (catsEl) catsEl.querySelectorAll("li.is-active").forEach(el => el.classList.remove("is-active"));
    const vendorsEl = $default.querySelector(".efx-pop-vendors");
    if (vendorsEl) vendorsEl.querySelectorAll("li.is-active").forEach(el => el.classList.remove("is-active"));
    activeCatHandle  = null;
    activeVendorName = null;
    efxPreviewQuery(query);
  }, 120);

  if (!efxIsCoarse()) {
    qEl.querySelectorAll("li[data-query]").forEach(li => {
      efxHoverIntent(li, () => { hoverLoadQuery(li.dataset.query, li); });
    });
  }
}

// === Dedup helpers ===
function efxExtractHandleFromUrl(url) {
  if (!url) return "";
  try {
    const u = new URL(url, location.origin);
    const parts = u.pathname.split("/").filter(Boolean);
    const i = parts.indexOf("products");
    return (i !== -1 && parts[i + 1]) ? parts[i + 1].toLowerCase() : "";
  } catch { return ""; }
}
function efxPriceNum(val) {
  if (val == null) return NaN;
  if (typeof val === "number") return +val;
  const n = parseFloat(String(val).replace(/[^\d.,-]/g, "").replace(",", "."));
  return isNaN(n) ? NaN : +n;
}
function efxDedupKey(it) {
  if (it.id) return `id:${it.id}`;
  const handle = (it.handle || efxExtractHandleFromUrl(it.url) || "").trim().toLowerCase();
  if (handle) return `h:${handle}`;
  const t = (it.title || "").toLowerCase().trim();
  const p = efxPriceNum(it.price);
  return `tp:${t}:${isNaN(p) ? "nan" : p.toFixed(2)}`;
}

// === Vendor list & products render ===
let activeCatHandle   = (window.EFX_SETTINGS?.popularCats || [])[0]?.handle || null;
let activeVendorName  = null;

function showProducts(items) {
  const mount = $results.querySelector(".efx-product-grid") || $default.querySelector(".efx-product-grid");
  if (!mount) return;
  const normalized = (items || []).slice(0, EFX_LIMIT).map(it => ({
    url: it.url,
    image: it.image,
    title: it.title,
    price: it.price,
    compareAtPrice: it.compareAtPrice,
    handle: it.handle || efxExtractHandleFromUrl(it.url),
    vendor: it.vendor
  }));
  efxInitSlider(mount, normalized);
}

function renderVendorList(vendors, query) {
  const vendorsEl = $results.querySelector(".efx-pop-vendors");
  if (!vendorsEl) return;

  const base = Array.isArray(vendors) ? vendors : [];
  let filtered = base;

  if (Array.isArray(dbVendors) && dbVendors.length > 0) {
    filtered = base.filter(vn => {
      const row = efxFindDbVendor(vn);
      return row && efxIsVendorActive(row);
    });
  }
  const limited = filtered.slice(0, 8);

  vendorsEl.innerHTML = limited.map(vn => {
    const collUrl = efxGetVendorCollectionUrl(vn);
    const href = collUrl ? collUrl : efxVendorSearchHref(query, vn);
    return `<li data-vendor-name="${vn}"><a href="${href}">${vn}</a></li>`;
  }).join("");

  if (efxIsCoarse()) return;

  vendorsEl.querySelectorAll('li[data-vendor-name]').forEach(li => {
    efxHoverIntent(li, () => {
      if (!inSearchMode || !lastSearchResults) return;
      activeVendorName = li.dataset.vendorName;
      vendorsEl.querySelectorAll("li").forEach(el =>
        el.classList.toggle("is-active", el === li)
      );
      const filteredProducts = lastSearchResults.filter(it => it.vendor === activeVendorName);
      showProducts(filteredProducts);
      renderSeeAllResults(query);
    });
  });
}

// === See All button helpers ===
function renderSeeAllDefault() {
  const cont = $default.querySelector(".efx-search-all-products");
  let href = "/";
  if (activeCatHandle) {
    href = `/collections/${activeCatHandle}`;
  } else if (activeVendorName) {
    href = `/collections/${activeVendorName}`;
  }
  if (cont) cont.innerHTML = `<a class="efx-see-all" href="${href}">Tüm Ürünleri Görüntüle</a>`;
  // Arama yokken (varsayılan görünüm) üstteki "Tümünü Gör" gizli (kullanıcı kararı)
  const top = $default.querySelector(".efx-see-all-top");
  if (top) top.hidden = true;
}
function renderSeeAllResults(query) {
  const q = (query || "").trim();
  let href = `/search?q=${encodeURIComponent(query)}&filter.v.availability=1&sort_by=relevance`;
  if (activeVendorName) href += `&filter.p.vendor=${encodeURIComponent(activeVendorName)}`;
  const cont = $results.querySelector(".efx-search-all-products");
  if (cont) cont.innerHTML = `<a class="efx-see-all" href="${href}">Tüm Ürünleri Görüntüle</a>`;
  // Arama varken üstteki "Tümünü Gör →" arama sayfasına gider; boşken gizli
  const top = $results.querySelector(".efx-see-all-top");
  if (top) { top.setAttribute("href", href); top.hidden = !q; }
}

function renderRecentSearches(mountEl) {
  if (!mountEl) return;
  const STORAGE_KEY = "efx_recent_searches";
  const getRecentSearches = () => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); }
    catch { return []; }
  };
  const setRecentSearches = (arr) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(arr || []));
  };
  const items = getRecentSearches();
  if (!items.length) { mountEl.innerHTML = ""; return; }

  mountEl.innerHTML = items.map(q => `
    <li class="efx-recent-li" style="display:flex;align-items:center;justify-content:space-between;gap:6px;white-space:nowrap">
      <button class="efx-recent-item" type="button" data-q="${q.replace(/"/g,"&quot;")}" style="flex:1;text-align:left;">
        ${q}
      </button>
      <button class="efx-recent-remove" type="button" data-q="${q.replace(/"/g,"&quot;")}" title="Kaldır" aria-label="Kaldır">×</button>
    </li>
  `).join("");

  if (mountEl.__recentHandler) {
    mountEl.removeEventListener("click", mountEl.__recentHandler);
  }
  mountEl.__recentHandler = (e) => {
    const removeBtn = e.target.closest(".efx-recent-remove");
    if (removeBtn) {
      e.preventDefault(); e.stopPropagation();
      const q = removeBtn.dataset.q || "";
      if (!q) return;
      let arr = getRecentSearches();
      arr = arr.filter(item => item.trim() !== q.trim());
      setRecentSearches(arr);
      const li = removeBtn.closest(".efx-recent-li");
      if (li) li.remove();
      if (!arr.length) mountEl.innerHTML = "";
      return;
    }
    const pickBtn = e.target.closest(".efx-recent-item");
    if (pickBtn) {
      const q = pickBtn.dataset.q || "";
      if (q) window.location.href = `/search?q=${encodeURIComponent(q)}&filter.v.availability=1&sort_by=relevance`;
    }
  };
  mountEl.addEventListener("click", mountEl.__recentHandler);
}

// ——— Predictive + Search birleştir, SPINNER ile render et ———
async function efxLoadPopularSearch(query) {
  efxCancelInFlight();
  const myReq = ++efxSearchReqId;

  try {
    // sonuç kabuğu + spinner (hemen boyansın)
    const grid = efxEnsureResultsShell();
    const qEl = $results.querySelector('.efx-query'); if(qEl) qEl.textContent = `“${query}”`;
    efxShowSpinner(grid);
    await efxNextPaint();

    // aktif durumları paint'ten sonra sıfırla
    $default.querySelector(".efx-pop-cats")?.querySelectorAll("li.is-active").forEach(li => li.classList.remove("is-active"));
    $default.querySelector(".efx-pop-vendors")?.querySelectorAll("li.is-active").forEach(li => li.classList.remove("is-active"));
    activeCatHandle = null; activeVendorName = null;

    // predictive + search paralel (biri çökerse diğeri devam)
    const [predSet, searchSet] = await Promise.allSettled([
      efxFetchPredictive(query),
      efxFetchSearch(query)
    ]);
    if (myReq !== efxSearchReqId) return;

    const predItems = (predSet.status==='fulfilled'
      ? (predSet.value?.resources?.results?.products||[]) : []);
    const searchArray = (searchSet.status==='fulfilled' && Array.isArray(searchSet.value))
      ? searchSet.value : [];

    // merge + dedup
    const seen = new Set();
    const merged = [...predItems, ...searchArray].filter(it => {
      const key = efxDedupKey(it);
      if (!key || seen.has(key)) return false;
      seen.add(key); return true;
    });

    inSearchMode = true;
    lastSearchResults = merged;

    // spinner yerine ürünleri bas
    efxInitSlider(grid, merged);

    // vendor listesi + "Tümünü Gör"
    const uniqVendors = Array.from(new Set(merged.map(it=>it.vendor).filter(Boolean)));
    renderVendorList(uniqVendors, query);
    renderSeeAllResults(query);
    efxUpdateSidebarVisibility();

  } catch (err) {
    if (myReq !== efxSearchReqId) return;
    inSearchMode = false;
    lastSearchResults = null;
    $results.innerHTML = `<div class="efx-error">Arama hatası: ${err.message}</div>`;
    console.error(err);
  }
}

function efxRenderProducts(products) {
  const grid = $default.querySelector(".efx-product-grid");
  efxInitSlider(grid, products);
  renderSeeAllDefault();
}

// === Data ===
const popularCats    = window.EFX_SETTINGS?.popularCats || [];
const popularQueries = window.EFX_SETTINGS?.popularQueries || [];
const popularVendors = window.EFX_SETTINGS?.popularVendors || [];

// === Load ===
async function efxLoadPopular(handle) {
  if (!handle) return;
  try {
    inSearchMode = false;
    lastSearchResults = null;

    const grid = $default.querySelector(".efx-product-grid");
    efxShowSpinner(grid);
    await efxNextPaint();

    const products = await efxFetchPopularProducts(handle, 20);
    activeCatHandle = handle;

    const catsEl = $default.querySelector(".efx-pop-cats");
    if (catsEl) {
      catsEl.querySelectorAll("li[data-handle]").forEach(li => {
        li.classList.toggle("is-active", li.dataset.handle === activeCatHandle);
      });
    }
    const vendorsEl = $default.querySelector(".efx-pop-vendors");
    if (vendorsEl) vendorsEl.querySelectorAll("li.is-active").forEach(li => li.classList.remove("is-active"));
    const queriesEl = $default.querySelector(".efx-pop-queries");
    if (queriesEl) queriesEl.querySelectorAll("li.is-active").forEach(li => li.classList.remove("is-active"));

    activeVendorName = null;
    efxRenderProducts(products);
  } catch (err) {
    console.error(`Popüler ürünler (${handle}) yüklenemedi:`, err);
  }
}

async function efxLoadPopularVendor(vendorHandle) {
  try {
    inSearchMode = false;
    lastSearchResults = null;

    const grid = $default.querySelector(".efx-product-grid");
    efxShowSpinner(grid);
    await efxNextPaint();

    const products = await efxFetchPopularProducts(vendorHandle, 20); // vendor değil, koleksiyon handle
    activeVendorName = vendorHandle;

    const vendorsEl = $default.querySelector(".efx-pop-vendors");
    if (vendorsEl) {
      vendorsEl.querySelectorAll("li[data-vendor-handle]").forEach(li => {
        li.classList.toggle("is-active", li.dataset.vendorHandle === activeVendorName);
      });
    }
    const catsEl = $default.querySelector(".efx-pop-cats");
    if (catsEl) catsEl.querySelectorAll("li.is-active").forEach(li => li.classList.remove("is-active"));
    const queriesEl = $default.querySelector(".efx-pop-queries");
    if (queriesEl) queriesEl.querySelectorAll("li.is-active").forEach(li => li.classList.remove("is-active"));

    activeCatHandle = null;
    efxRenderProducts(products);
  } catch (err) {
    console.error(`Popüler vendor (${vendorHandle}) yüklenemedi:`, err);
  }
}

// === Mobil body scroll lock ===
// iOS Safari preventScroll'u guvenilir desteklemiyor: drawer input'a focus
// verince sayfa yukari kayar. Bunu engellemek icin body'yi position:fixed yapip
// scroll Y'yi negative top olarak korur, drawer kapaninca geri yukleriz.
let efxScrollY = 0;
function efxLockScroll() {
  if (!efxIsMobile()) return;
  // Cat drawer zaten kilitlemis olabilir (m-cat-lock). Yeniden kilitleme.
  if (document.body.classList.contains('m-cat-lock')) return;
  if (document.body.style.position === 'fixed') return;
  efxScrollY = window.scrollY || window.pageYOffset || 0;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${efxScrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
}
function efxUnlockScroll() {
  if (!efxIsMobile()) return;
  // Mevcut top'u oku (bizim veya cat drawer'in koymus olabilir).
  const existingTop = document.body.style.top;
  const restoreY = existingTop ? Math.abs(parseInt(existingTop, 10)) : efxScrollY;
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.body.classList.remove('m-cat-lock'); // cat drawer arka planda acik kalmissa onu da temizle
  if (restoreY) window.scrollTo(0, restoreY);
}

// === Panel kontrol ===
function efxOpen() {
  inSearchMode = false;
  lastSearchResults = null;

  // Mobilde body'yi kilitle: focus drawer input'a sayfa kaymasin
  efxLockScroll();

  $overlay.classList.add("is-open");
  document.body.classList.add("efx-no-scroll");
  $default.hidden = false;
  $results.hidden = true;

  // Mobil: page input degerini drawer input'a kopyala
  if (efxIsMobile()) {
    const pageInp = document.querySelector('.efx-main-search__input');
    const drawerInp = document.querySelector('.efx-drawer-input');
    if (pageInp && drawerInp) {
      drawerInp.value = pageInp.value;
      const clearBtn = document.querySelector('.efx-drawer-clear');
      if (clearBtn) clearBtn.hidden = !drawerInp.value;
    }
  }

  if (popularVendors.length) {
    efxRenderPopularVendors(popularVendors);
  }
  efxRenderPopularCats(popularCats, activeCatHandle);
  efxRenderQueries(popularQueries);

  if (!activeCatHandle && popularCats.length) {
    activeCatHandle = popularCats[0].handle;
  }

  const recentMount = $default.querySelector(".efx-pop-recent-search");
  renderRecentSearches(recentMount, (pickedQ) => {
    // Mobilde drawer input aktif, desktop'ta page input
    const activeInput = efxIsMobile()
      ? document.querySelector(".efx-drawer-input")
      : document.querySelector(".efx-main-search__input");
    if (activeInput) {
      activeInput.value = pickedQ;
      const clearBtn = document.querySelector('.efx-drawer-clear');
      if (clearBtn && efxIsMobile()) clearBtn.hidden = !activeInput.value;
      onTypeImmediate({ target: activeInput });
      onType({ target: activeInput });
    }
  });

  const activeInput = efxIsMobile()
    ? document.querySelector(".efx-drawer-input")
    : document.querySelector(".efx-main-search__input");
  if (activeInput && activeInput.value.trim().length >= EFX_MIN_LEN) {
    onType({ target: activeInput });
    return;
  }

  if (activeCatHandle) efxLoadPopular(activeCatHandle);
  efxUpdateSidebarVisibility();
}

function efxClose() {
  // Mobil: drawer input degerini page input'a geri yaz (kullanici acipsa kapatirsa value korunur)
  if (efxIsMobile()) {
    const pageInp = document.querySelector('.efx-main-search__input');
    const drawerInp = document.querySelector('.efx-drawer-input');
    if (pageInp && drawerInp) pageInp.value = drawerInp.value;
    // Klavyeyi kapat
    if (drawerInp) try { drawerInp.blur(); } catch {}
  }

  $overlay.classList.remove("is-open");
  document.body.classList.remove("efx-no-scroll");
  efxUnlockScroll(); // mobil body lock'u kaldir
  efxResetAll();
  efxUpdateSidebarVisibility();
}

function efxResetAll() {
  inSearchMode = false;
  lastSearchResults = null;

  activeCatHandle = null;
  activeVendorName = null;

  document.querySelectorAll(".efx-search-overlay .is-active").forEach(el => el.classList.remove("is-active"));

  const gridDefault = $default?.querySelector(".efx-product-grid");
  if (gridDefault) gridDefault.innerHTML = "";

  if ($results) {
    $results.innerHTML = "";
    $results.hidden = true;
    delete $results.__shell;
  }

  if ($default) $default.hidden = false;
  renderSeeAllDefault();
  efxUpdateSidebarVisibility();
}

$overlay.addEventListener("click", (e) => {
  if (e.target === $overlay) efxClose();
});
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") efxClose();
});

// === Input dinleme ===
const inputs = document.querySelectorAll(".efx-main-search__input");
inputs.forEach((inp) => {
  inp.addEventListener("focus", efxOpen);
  inp.addEventListener("click", efxOpen);

  // Mobil: page input focus'unu drawer input'a yonlendir.
  // pointerdown native focus'tan once tetiklenir; preventDefault ile page input
  // focus olmaz, drawer acilir ve drawer input ayni user-gesture icinde focus alir
  // (iOS klavye gostermek icin bu sart).
  inp.addEventListener("pointerdown", (e) => {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    e.preventDefault();
    const drawerInp = document.querySelector('.efx-drawer-input');
    if (!drawerInp) { efxOpen(); return; }
    drawerInp.value = inp.value;
    efxOpen();
    drawerInp.focus({ preventScroll: true });
    try {
      drawerInp.setSelectionRange(drawerInp.value.length, drawerInp.value.length);
    } catch {}
  });
});

// Mobil: bos input ile search butonuna basinca /search'e gitme, drawer'i ac
document.querySelectorAll('.main-search__form').forEach((form) => {
  form.addEventListener('submit', (e) => {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    const inp = form.querySelector('.efx-main-search__input');
    if (!inp) return;
    if (inp.value.trim()) return; // dolu ise normal submit (search sayfasina git)
    e.preventDefault();
    efxOpen();
    const drawerInp = document.querySelector('.efx-drawer-input');
    if (drawerInp) {
      try { drawerInp.focus({ preventScroll: true }); } catch {}
    }
  });
});

// Mobil float arama butonu (.m-float-search): drawer'i ac.
// Delegasyon kullaniyoruz: tum sablonlarda (collection dahil) ve header yeniden
// render olsa bile calisir. pointerdown ile preventDefault + ayni gesture icinde
// drawer input'u focus ediyoruz (iOS klavyesi icin sart).
document.addEventListener("pointerdown", (e) => {
  const btn = e.target.closest && e.target.closest(".m-float-search");
  if (!btn) return;
  if (!window.matchMedia('(max-width: 767px)').matches) { efxOpen(); return; }
  e.preventDefault();
  efxOpen();
  const drawerInp = document.querySelector('.efx-drawer-input');
  if (drawerInp) {
    drawerInp.focus({ preventScroll: true });
    try { drawerInp.setSelectionRange(drawerInp.value.length, drawerInp.value.length); } catch {}
  }
});

// 1) ANINDA spinner (debounce YOK) — sadece UI
async function onTypeImmediate(ev){
  const q = ev.target.value.trim();

  if (q.length < EFX_MIN_LEN) {
    efxCancelInFlight(); // önceki aramayı iptal et
    inSearchMode = false;
    lastSearchResults = null;
    $default.hidden = false;
    $results.hidden = true;
    if (!activeCatHandle && popularCats.length) activeCatHandle = popularCats[0].handle;
    // Popülerler asenkron yüklenir (spinner içeride)
    if (activeCatHandle) efxLoadPopular(activeCatHandle);
    efxUpdateSidebarVisibility();
    return;
  }

  // Arama modu — sonuç kabuğunu hazırla ve spinner'ı ANINDA göster
  const gridEarly = efxEnsureResultsShell();
  const qElEarly = $results.querySelector('.efx-query'); if (qElEarly) qElEarly.textContent = `“${q}”`;
  efxShowSpinner(gridEarly);
  // kullanıcıya hemen boyat
  await efxNextPaint();
}

// 2) AĞ çağrılarını yapan debounce'lu handler
const onType = efxBounce(async (ev) => {
  const q = ev.target.value.trim();

  if (q.length < EFX_MIN_LEN) {
    // (onTypeImmediate zaten UI'ı geri aldı)
    return;
  }

  try {
    await efxLoadPopularSearch(q);
  } catch (err) {
    inSearchMode = false;
    lastSearchResults = null;
    if (err.name !== "AbortError") {
      $results.innerHTML = `<div class="efx-error">Arama hatası: ${err.message}</div>`;
      console.error(err);
    }
  }
}, 220);

// Mobil drawer mode helper
const efxIsMobile = () => window.matchMedia('(max-width: 767px)').matches;

// Overlay top offset (sticky header/announcement bar için)
function updateOverlayTop() {
  const overlay = document.querySelector('.efx-search-overlay');
  if (!overlay) return;

  // Mobilde drawer full-screen
  if (efxIsMobile()) {
    overlay.style.setProperty('--efx-overlay-top', '0px');
    return;
  }

  // 1) Tercihen arama inputunun altına hizala
  const input = document.querySelector('.efx-main-search__input');
  let topPx = 100; // desktop varsayılanı

  topPx = (window.innerWidth > 1200)
      ? (window.scrollY > 40 ? 65 : 100)
      : 100;

  overlay.style.setProperty('--efx-overlay-top', `${topPx}px`);
}

window.addEventListener('scroll', updateOverlayTop);
window.addEventListener('resize', updateOverlayTop);
document.addEventListener('DOMContentLoaded', () => {
  updateOverlayTop();
  renderSeeAllDefault();
  efxUpdateSidebarVisibility();
});

// input değişimini bağla
inputs.forEach((el) => {
  el.addEventListener("input", onTypeImmediate); // ← hemen spinner
  el.addEventListener("input", onType);          // ← debounce’lu fetch
});

// === Mobil drawer header wiring ===
(function wireDrawerHeader(){
  const drawerInp = document.querySelector('.efx-drawer-input');
  const backBtn   = document.querySelector('.efx-drawer-back');
  const clearBtn  = document.querySelector('.efx-drawer-clear');
  if (!drawerInp) return;

  // Yazma -> mevcut search handler'lari
  drawerInp.addEventListener('input', onTypeImmediate);
  drawerInp.addEventListener('input', onType);
  drawerInp.addEventListener('input', () => {
    if (clearBtn) clearBtn.hidden = !drawerInp.value;
  });

  // Enter -> arama sayfasina submit
  drawerInp.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const q = drawerInp.value.trim();
    if (!q) return;
    saveRecentSearch(q);
    window.location.href = '/search?q=' + encodeURIComponent(q);
  });

  if (backBtn) backBtn.addEventListener('click', () => efxClose());

  if (clearBtn) clearBtn.addEventListener('click', () => {
    drawerInp.value = '';
    clearBtn.hidden = true;
    onTypeImmediate({ target: drawerInp });
    onType({ target: drawerInp });
    drawerInp.focus({ preventScroll: true });
  });
})();

// RECENTS
function getRecentSearches() {
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch { return []; }
}
function saveRecentSearch(q) {
  const term = (q || "").trim();
  if (!term) return;
  let arr = getRecentSearches();
  arr = [term, ...arr.filter(x => x.toLowerCase() !== term.toLowerCase())]
          .slice(0, RECENT_MAX);
  localStorage.setItem(RECENT_KEY, JSON.stringify(arr));
}
function clearRecentSearches() {
  localStorage.removeItem(RECENT_KEY);
}

// global export (opsiyonel)
window.efxOpen = efxOpen;
window.efxClose = efxClose;
